(() => {
  const normalize = (value = '') => value.replace(/\s+/g, ' ').trim().toLowerCase();

  const isSizeHeading = (node) => {
    const text = normalize(node.textContent);
    return text === 'size guide' || text === 'size chart' || text === 'sizing' || text === 'sizing guide';
  };

  const markPlainSizeTables = (scope = document) => {
    const products = scope.matches?.('[data-product-context]')
      ? [scope]
      : Array.from(scope.querySelectorAll?.('[data-product-context]') || []);

    products.forEach((product) => {
      const description = product.querySelector('.product__description');
      if (!description) return;

      const alreadyTagged = description.querySelector(
        '.sbl-size-guide-container, table#size-guide, .sbl-size-table, [class*="size-chart"], [id*="size-chart"]'
      );
      if (alreadyTagged) return;

      const headings = Array.from(description.querySelectorAll('h2, h3, h4, h5'));
      const heading = headings.find(isSizeHeading);
      if (!heading) return;

      let candidate = heading.nextElementSibling;
      while (candidate && !candidate.matches('table')) {
        const nestedTable = candidate.querySelector?.('table');
        if (nestedTable) {
          candidate = nestedTable;
          break;
        }
        if (candidate.matches('h2, h3, h4, h5')) return;
        candidate = candidate.nextElementSibling;
      }

      if (!candidate || !candidate.matches('table')) return;
      if (!candidate.id) candidate.id = 'size-guide';
      heading.remove();
    });
  };

  const removeSupplierNotes = (scope = document) => {
    const guides = scope.matches?.('[data-majbwr-compact-size-guide]')
      ? [scope]
      : Array.from(scope.querySelectorAll?.('[data-majbwr-compact-size-guide]') || []);

    guides.forEach((guide) => {
      if (!guide.querySelector('table')) return;
      guide.querySelector('.majbwr-compact-size-guide__note')?.remove();
    });
  };

  const run = (scope = document) => {
    markPlainSizeTables(scope);
    window.requestAnimationFrame(() => removeSupplierNotes(scope));
  };

  const init = () => run(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  document.addEventListener('shopify:section:load', (event) => run(event.target));
})();
